export default __webpack_public_path__ + "static/media/second-pickup-status.efc56322.svg";